import { openSettingsPage } from './consentLayer';

/**
 * Function to open the consent page if the `?openPrivacyManagerModal` query param
 * is provided.
 */
const openPrivacyManagerModal = () => {
  if (window.location.search.includes('openPrivacyManagerModal')) {
    openSettingsPage(window._sp_ss_config.privacyManagerModalId);
  }
};

export default openPrivacyManagerModal;
